import { getApiBaseUrl } from '../utils/apiConfig.js';

const API_BASE_URL = getApiBaseUrl();
const VN_EVISA_API = `${API_BASE_URL}/vn-evisa`;

export async function uploadVnEvisaFile(file, purpose) {
  const formData = new FormData();
  formData.append('file', file);

  const url = new URL(`${VN_EVISA_API}/uploads`);
  if (purpose) {
    url.searchParams.append('purpose', purpose);
  }

  const resp = await fetch(url.toString(), {
    method: 'POST',
    body: formData,
    credentials: 'include',
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || '上传失败');
  }

  return resp.json();
}

export async function createVnEvisaApplication(payload) {
  const resp = await fetch(`${VN_EVISA_API}/applications`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    credentials: 'include',
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '创建任务失败');
  }
  return data;
}

export async function getVnEvisaStatus(taskId) {
  const resp = await fetch(`${VN_EVISA_API}/applications/${taskId}`, {
    credentials: 'include',
  });
  if (resp.status === 404) {
    throw new Error('任务不存在');
  }
  const data = await resp.json();
  if (!resp.ok) {
    throw new Error(data?.detail || '获取状态失败');
  }
  return data;
}

export async function submitVnEvisaCaptcha(taskId, payload) {
  const resp = await fetch(`${VN_EVISA_API}/applications/${taskId}/captcha`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  const data = await resp.json();
  if (!resp.ok) {
    throw new Error(data?.detail || '验证码提交失败');
  }
  return data;
}

export async function getVnEvisaCaptchaImage(taskId) {
  const resp = await fetch(`${VN_EVISA_API}/applications/${taskId}/captcha-image`, {
    credentials: 'include',
  });
  if (resp.status === 404) {
    return null; // 验证码还未准备好
  }
  const data = await resp.json();
  if (!resp.ok) {
    throw new Error(data?.detail || '获取验证码图片失败');
  }
  return data;
}

export async function listVnEvisaTasks(limit = 20) {
  const resp = await fetch(`${VN_EVISA_API}/applications?limit=${limit}`, {
    credentials: 'include',
  });
  if (!resp.ok) {
    const data = await resp.json().catch(() => ({}));
    throw new Error(data?.detail || '获取任务列表失败');
  }
  return resp.json();
}

export async function getVnEvisaLocations() {
  const resp = await fetch(`${VN_EVISA_API}/locations`, {
    credentials: 'include',
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '获取省/市列表失败');
  }
  return data;
}

export async function getVnEvisaBorderGates() {
  const resp = await fetch(`${VN_EVISA_API}/border-gates`, {
    credentials: 'include',
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '获取口岸列表失败');
  }
  return data;
}

export async function retryVnEvisaTask(taskId) {
  const resp = await fetch(`${VN_EVISA_API}/applications/${taskId}/retry`, {
    method: 'POST',
    credentials: 'include',
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '重试失败');
  }
  return data;
}
